var _styled;

import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
var StyledParagraph = styled('p')((_styled = {
  fontFamily: NTA_LIGHT,
  fontSize: FONT_SIZE.SIZE_18,
  lineHeight: LINE_HEIGHT.SIZE_18,
  marginTop: 0
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_24,
  lineHeight: LINE_HEIGHT.SIZE_24
}, _styled));
/**
 *
 * ### Usage
 *
 *
 * Simple
 * ```jsx
 * <LeadParagraph>LeadParagraph example</LeadParagraph>
 * ```
 *
 * ### References
 * - https://govuk-static.herokuapp.com/component-guide/lead_paragraph
 */

var LeadParagraph = function LeadParagraph(props) {
  return React.createElement(StyledParagraph, props);
};

export default withWhiteSpace({
  marginBottom: 5
})(LeadParagraph);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/lead-paragraph/es/index.js
// module id = 313
// module chunks = 0